import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-delete',
	path: '/secure/admin/DeleteNotification([!%]?[\\w]*).jspa',
};
